export default __webpack_public_path__ + "static/media/Sprayer.409fa304.jpg";